import { css, styled } from "styled-components";

import { CrossIcon, PlusIcon } from "common/components/icons";
import { UITagButton } from "common/components/UITag";

const StyledTag = styled(UITagButton)`
  display: flex;
  margin: 0 10px 10px 0;
`;

const iconStyle = css`
  width: 14px;
  height: 14px;
  margin-left: 10px;
  cursor: pointer;
`;

const StyledIconContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledAddIcon = styled(PlusIcon)`
  ${iconStyle}
`;

const StyledCrossIcon = styled(CrossIcon)`
  ${iconStyle}
`;

const StyledTagLabel = styled.div<{ fontSize?: string | number }>`
  display: inline-block;
  max-width: 230px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: ${({ fontSize }) => (fontSize ? (typeof fontSize === "number" ? `${fontSize}px` : fontSize) : "16px")};
`;

type AutocompleteOptionTagProps = {
  label: string;
  dataTestId?: string;
  disabled?: boolean;
  isSelected?: boolean;
  labelFontSize?: string | number;
  onClick?: () => void;
};

export const AutocompleteOptionTag = ({
  label,
  dataTestId,
  disabled,
  isSelected,
  labelFontSize,
  onClick,
}: AutocompleteOptionTagProps) => {
  const getIconFromType = () => {
    if (isSelected) return <StyledCrossIcon />;

    return <StyledAddIcon />;
  };

  const ariaDescription = isSelected ? "Press to deselect option" : "Press to select option";

  return (
    <StyledTag
      dataTestId={dataTestId}
      isDisabled={disabled}
      onClick={onClick}
      isActive={isSelected}
      title={label}
      aria-description={ariaDescription}
    >
      <StyledTagLabel fontSize={labelFontSize}>{label}</StyledTagLabel>
      {!disabled && <StyledIconContainer>{getIconFromType()}</StyledIconContainer>}
    </StyledTag>
  );
};
